import {makeGetAuthorizationsOdontoTrack} from 'main/factories/usecases/private/authorizations/get-authorizations-odonto-track';
import {AuthorizationsOdontoTrackItem} from 'domain/usecases/private/authorizations/get-authorizations-odonto-track';
import {PortalTimelineData} from 'presentation/components/Timeline/types';
import {GetAuthOdontoStatusTrackParams} from './types';
import {formatOdontoStatusTitle} from '../../../utils';

export const getAuthOdontoStatusTrack = async ({
	authorizationCode,
	procedureCode,
	procedureKeyCode,
}: GetAuthOdontoStatusTrackParams): Promise<PortalTimelineData[]> => {
	try {
		const getAuthorizationsOdontoTrackUseCase = makeGetAuthorizationsOdontoTrack();

		const response = await getAuthorizationsOdontoTrackUseCase.get({
			authorizationCode,
			procedureCode,
			procedureKeyCode,
		});

		const formattedData: PortalTimelineData[] = response.content.map(
			(item: AuthorizationsOdontoTrackItem) => ({
				title: formatOdontoStatusTitle(item.statusAuthorization),
				description: item.statusAuthorizationDate,
			}),
		);

		return formattedData;
	} catch (error) {
		throw new Error();
	}
};
